import EmployeePage from './EmployeesPage';

export default EmployeePage;
